import { useEffect, useRef } from 'react';
import Tooltip from 'bootstrap/js/dist/tooltip';

function RatingStars({ rating, reviews }) {
  const tooltipRef = useRef(null);

  const hasRating = Number(rating) > 0;

  const rounded = hasRating
    ? Math.round(rating * 2) / 2
    : 0;

  useEffect(() => {
    if (!hasRating || !tooltipRef.current) return;

    const tooltip = new Tooltip(tooltipRef.current, {
      title: rating.toFixed(1)+' stars | '+reviews+' reviews',
      trigger: 'hover focus',
      placement: 'top',
    });

    return () => tooltip.dispose();
  }, [hasRating, rating]);

  // ⬅️ ОЦЕ КЛЮЧОВЕ
  if (!hasRating) return null;

  const stars = [];
  for (let i = 1; i <= 5; i++) {
    if (rounded >= i) {
      stars.push(<i key={i} className="fa-solid fa-star"></i>);
    } else if (rounded + 0.5 === i) {
      stars.push(<i key={i} className="fa-solid fa-star-half-stroke"></i>);
    } else {
      stars.push(<i key={i} className="fa-regular fa-star"></i>);
    }
  }

  return (
    <div className="rating">
      <span
        ref={tooltipRef}
        className="rating-stars"
        tabIndex={0}
        role="button"
        aria-label={`Rating ${rating.toFixed(1)}`}
        onClick={(e) => e.stopPropagation()}
        onMouseDown={(e) => e.stopPropagation()}
      >
        {stars}
      </span>

      {reviews ? <span className="ms-1 reviews">{reviews}</span> : null}
    </div>
  );
}

export default RatingStars;
